import { CloseIcon } from '@mm/icons';
import {
  FilterItem,
  SystemFilterItem,
  TagFilterItem,
} from '@mm/state/model/AudiencesModel';
import { colors } from '@mm/utils';
import classNames from 'classnames';
import React from 'react';
import styles from './FilterBarItem.module.css';
import { FilterBarPlatformFilter } from './FilterBarPlatformFilter';
import { FilterBarTagFilter } from './FilterBarTagFilter';
import { FilterBarVariableFilter } from './FilterBarVariableFilter';

type Filter = Partial<FilterItem> | SystemFilterItem | TagFilterItem;
interface Props {
  className?: string;
  filter: Filter;
  onUpdate: (updatedFilter: Filter | undefined) => void;
  onStartEdit: () => void;
  onCancelEdit: () => void;
  editing: boolean;
  css?: {
    component?: string;
    deleteContainer?: string;
    deleteButton?: string;
  };
  styles?: React.CSSProperties;
  hideDelete?: boolean;
}
export type FilterBarItemContentProps<T> = Props & {
  filter: T;
  onUpdate: (updatedFilter: T | undefined) => void;
  styles: typeof styles;
};
export const FilterBarItem = (props: Props) => {
  const { filter, onUpdate, editing, className, css, hideDelete } = props;
  const ContentComponent = (() => {
    switch (filter.filterType) {
      case 'platform':
        return FilterBarPlatformFilter;
      case 'variable_values':
        return FilterBarVariableFilter;
      case 'tags_filters':
        return FilterBarTagFilter;
      case 'eu_limits':
        return () => (
          <>
            <strong>EU Membership:</strong>&nbsp;
            {(filter as SystemFilterItem).value}
          </>
        );
      case 'reachable':
        return () => (
          <>
            <strong>Reachable:</strong>&nbsp;
            {(filter as SystemFilterItem).value}
          </>
        );

      default:
        return () => <>{JSON.stringify(filter, null, 2)}</>;
    }
  })();
  return (
    <div
      className={classNames(className, styles.container, {
        [styles.content__editing]: editing,
      })}
    >
      <ContentComponent
        {...props}
        filter={filter as never}
        styles={styles}
        className={css?.component}
      />
      {!hideDelete && (
        <div
          className={classNames(
            styles.deleteButtonContainer,
            css?.deleteContainer,
          )}
        >
          <CloseIcon
            color={colors.accentBlue}
            className={styles.deleteButton}
            onClick={() => onUpdate(undefined)}
          />
        </div>
      )}
    </div>
  );
};
